import SEOPage from "./SEOPage";

export default function FertilityClinicAmbala() {
  return (
    <SEOPage
      title="Fertility Clinic in Ambala | Amaanat IVF Clinic"
      description="Leading Fertility Clinic in Ambala providing IVF, IUI, ICSI, infertility evaluation, fertility counseling and reproductive healthcare."
      canonical="https://amaanativf.com/fertility-clinic-in-ambala"
      heading="Fertility Clinic in Ambala"
      focusKeyword="Fertility Clinic in Ambala"
    />
  );
}